import { IMG } from "./content";

// Regions RD Cleaning Services covers. Suburbs/towns are real WA localities.
export const REGIONS = [
  {
    slug: "north-of-river",
    name: "North of the River",
    short: "Perth Metro North",
    title: "Cleaning Services North of the River, Perth",
    blurb:
      "Regular home cleaning, end of lease cleans and office cleaning across Perth's northern suburbs — from the coast at Scarborough and Hillarys through to Joondalup, Stirling, Morley and the north-east corridor.",
    image: IMG.living,
    highlights: [
      "Weekly, fortnightly and monthly home cleaning",
      "End of lease and pre-inspection cleans for rentals",
      "Office, retail and strata common-area cleaning",
    ],
    suburbs: [
      "Scarborough", "Karrinyup", "Innaloo", "Osborne Park", "Stirling", "Balcatta",
      "Joondalup", "Hillarys", "Sorrento", "Duncraig", "Greenwood", "Kingsley",
      "Wanneroo", "Clarkson", "Butler", "Mindarie", "Yokine", "Dianella",
      "Morley", "Mount Lawley", "Inglewood", "Bayswater", "Ellenbrook", "Midland",
    ],
  },
  {
    slug: "east-perth",
    name: "East Perth & Inner East",
    short: "East Perth",
    title: "Cleaning Services in East Perth & the Inner East",
    blurb:
      "Apartment, townhouse and workplace cleaning through East Perth, the CBD fringe and the inner eastern suburbs — ideal for apartment living, short-stay turnovers and small offices.",
    image: IMG.interior,
    highlights: [
      "Apartment and high-rise cleaning, including common areas",
      "Short-stay and rental turnover cleans",
      "After-hours office and consulting-room cleaning",
    ],
    suburbs: [
      "East Perth", "Perth CBD", "Northbridge", "West Perth", "Highgate",
      "Burswood", "Victoria Park", "Rivervale", "Ascot", "Belmont",
      "Maylands", "Bayswater", "Carlisle", "Lathlain", "South Perth",
    ],
  },
  {
    slug: "south-west",
    name: "Regional WA — South West",
    short: "South West",
    title: "Cleaning Services in the South West of WA",
    blurb:
      "Holiday home, residential and commercial cleaning through the South West — Mandurah, Bunbury, Busselton, Dunsborough and the Margaret River region. Ideal for accommodation turnovers and seasonal deep cleans.",
    image: IMG.endOfLease,
    highlights: [
      "Holiday rental and accommodation changeover cleans",
      "Seasonal deep cleans and spring cleaning",
      "Commercial, retail and hospitality cleaning",
    ],
    suburbs: [
      "Mandurah", "Pinjarra", "Harvey", "Australind", "Bunbury",
      "Eaton", "Capel", "Busselton", "Dunsborough", "Yallingup",
      "Margaret River", "Collie", "Donnybrook", "Vasse",
    ],
  },
  {
    slug: "mid-west",
    name: "Regional WA — Mid West",
    short: "Mid West",
    title: "Cleaning Services in the Mid West of WA",
    blurb:
      "Residential, commercial and industrial cleaning across the Mid West, centred on Geraldton and the surrounding coastal and inland towns. Scheduled site visits and project cleans available.",
    image: IMG.warehouse,
    highlights: [
      "Scheduled commercial and office cleaning runs",
      "Industrial, workshop and site cleaning",
      "End of lease and worker-accommodation cleans",
    ],
    suburbs: [
      "Geraldton", "Dongara", "Port Denison", "Northampton", "Kalbarri",
      "Jurien Bay", "Cervantes", "Three Springs", "Moora", "Mullewa",
      "Carnarvon", "Mingenew",
    ],
  },
];

export const findRegion = (slug) => REGIONS.find((r) => r.slug === slug);
